import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import { Link } from 'react-router-dom';
import {ApiBaseUrl} from '../../constants';
import { AuthContext } from "./../../context/auth";
import {withSnackbar} from "react-simple-snackbar";
import {trackPromise} from "react-promise-tracker";

class PasswordComponent extends Component{
    static contextType = AuthContext;
    state = {
        password : ''
    }

    componentDidMount(){
        window.scrollTo(0, 0)
    }

    handleOnChange = (event) => {
        this.setState({
            password: event.target.value
        })
    }
    handleFormSubmit = (event) => {
        event.preventDefault()
        const formBody = "phone=" + encodeURIComponent(this.props.location.state.phone_number)+'&password='+this.state.password;
        trackPromise(
        fetch(ApiBaseUrl + "/consumer/login",
            {
                method: 'POST',
                body: formBody,
                headers:
                    {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(!result.success)
                        this.props.openSnackbar(result.message)
                    else if (localStorage.getItem('silverbackAddToShare') != null) {
                        trackPromise(
                            fetch(ApiBaseUrl + "/consumer/cart_count/",
                            {
                                method: 'GET',
                                headers:
                                    {
                                        "Authorization": "Bearer "+result.data.token
                                    }
                                })
                                .then(res => res.json())
                                .then(
                                    (result2) => {
                                        if(result2.success){
                                            localStorage.setItem('silverbackCartCount', result2.data.count);
                                            this.context.cartCount=result2.data.count;
                                        }
                                        localStorage.setItem('silverbackToken', result.data.token);
                                        localStorage.setItem('silverbackAuthenticated', true);
                                        this.context.authenticated=true;
                                        this.context.token=result.data.token;

                                        const AddToShare = JSON.parse(localStorage.getItem('silverbackAddToShare'))
                                        if("host_id" in AddToShare) {
                                            const requestBody = 'deal_id=' + AddToShare.deal_id + '&host_id=' + AddToShare.host_id
                                            trackPromise(
                                                fetch(ApiBaseUrl + "/consumer/add_to_share/",
                                                    {
                                                        method: 'POST',
                                                        body: requestBody,
                                                        headers:
                                                            {
                                                                "Content-Type": "application/x-www-form-urlencoded",
                                                                "Authorization": "Bearer " + result.data.token
                                                            }
                                                    })
                                                    .then(res => res.json())
                                                    .then(
                                                        (result) => {
                                                            if (result.success) {
                                                                localStorage.removeItem('silverbackAddToShare');
                                                                if (AddToShare.deal_type === 'allday')
                                                                    this.props.history.push(process.env.PUBLIC_URL + '/allday/shared-deal/' + result.data._id);
                                                                else if (AddToShare.deal_type === 'oneday')
                                                                    this.props.history.push(process.env.PUBLIC_URL + '/oneday/shared-deal/' + result.data._id);
                                                                else
                                                                    this.props.history.push(process.env.PUBLIC_URL + '/allday/shared-deal/');
                                                            } else
                                                                this.props.openSnackbar(result.message)
                                                        },
                                                        // Note: it's important to handle errors here
                                                        // instead of a catch() block so that we don't swallow
                                                        // exceptions from actual bugs in components.
                                                        (error) => {
                                                            this.props.openSnackbar('Oops, something went wrong.')
                                                        }
                                                    )
                                            )
                                        }
                                        else{
                                            localStorage.removeItem('silverbackAddToShare');
                                            if(AddToShare.deal_type === 'allday')
                                                this.props.history.push(process.env.PUBLIC_URL + '/allday/deal/' + AddToShare.deal_id);
                                            else if(AddToShare.deal_type === 'oneday'){
                                                this.props.history.push(process.env.PUBLIC_URL + '/oneday/deal/' + AddToShare.deal_id);
                                            }
                                        }
                                    },
                                    // Note: it's important to handle errors here
                                    // instead of a catch() block so that we don't swallow
                                    // exceptions from actual bugs in components.
                                    (error) => {
                                        this.props.openSnackbar('Oops, something went wrong.')
                                    }
                                )
                        )
                    }
                    else {
                        trackPromise(
                            fetch(ApiBaseUrl + "/consumer/cart_count/",
                                {
                                    method: 'GET',
                                    headers:
                                        {
                                            "Authorization": "Bearer "+result.data.token
                                        }
                                })
                                .then(res => res.json())
                                .then(
                                    (result2) => {
                                        if(result2.success){
                                            localStorage.setItem('silverbackCartCount', result2.data.count);
                                            this.context.cartCount=result2.data.count;
                                        }
                                        localStorage.setItem('silverbackToken', result.data.token);
                                        localStorage.setItem('silverbackAuthenticated', true);
                                        this.context.authenticated=true;
                                        this.context.token=result.data.token;
                                        this.props.history.push(process.env.PUBLIC_URL+'/')
                                    },
                                    // Note: it's important to handle errors here
                                    // instead of a catch() block so that we don't swallow
                                    // exceptions from actual bugs in components.
                                    (error) => {
                                        this.props.openSnackbar('Oops, something went wrong.')
                                    }
                                )
                        )
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    render(){
        return(
            typeof this.props.location.state!='undefined' && !this.context.authenticated ?
            <div className="choose-deals-outer">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5 mx-auto">
                            <div className="changepswd-box cg--green">
                                <form autoComplete="off" onSubmit={this.handleFormSubmit}>
                                    <p className="old--text">Welcome back to Host4VIP, please enter password to sign in</p>
                                    <div className="changepswd-rows">
                                        <label>Password</label>
                                        <div className="eye">
                                            <input type="password" className="form-control" name="password" value={this.state.password} onChange={this.handleOnChange}/>
                                        </div>
                                    </div>
                                    <div className="btn-rowstack">
                                        <button className="entry-btn cancel-btn grad-on w-xs-100" type="submit">Next</button>
                                    </div>
                                </form>
                                <Link to={`${process.env.PUBLIC_URL}/forgot-password`} className="mail-text text-note">I forgot my password</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            :
            <Redirect to={{ pathname: process.env.PUBLIC_URL+'/', state: { from: this.props.location } }} />
        )
    }
}

export default withSnackbar(PasswordComponent,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});